"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interpolationConfig = void 0;

var _upperFirst2 = _interopRequireDefault(require("lodash/upperFirst"));

var _toUpper2 = _interopRequireDefault(require("lodash/toUpper"));

var _toLower2 = _interopRequireDefault(require("lodash/toLower"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Export `interpolationConfig`.
 */
var interpolationConfig = {
  escapeValue: false,
  format: function format(value, _format) {
    switch (_format) {
      case 'capitalize':
        return (0, _upperFirst2["default"])(value);

      case 'lowercase':
        return (0, _toLower2["default"])(value);

      case 'uppercase':
        return (0, _toUpper2["default"])(value);

      default:
        return value;
    }
  }
};
exports.interpolationConfig = interpolationConfig;